import FormField from "../form-field";
import ServiceLocator from "../../../../global/service-locator";
import Api from "../../../../lib/api";

export default class TelField extends FormField {
	constructor(params) {
		super(params);

		this.maskPattern = null;
		this.iti = null;
		this.cityId = craft.env.cityId || Api.currentCityId;
		this.selectedCountry = null;

		this.modalService = ServiceLocator.instance.modalService;

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('TelField: Root element is not defined!');
		}

		if (this.props.required === true || this.props.required === false) {
			this.required = this.props.required;
		} else {
			this.required = (this.$root.dataset.required && this.$root.dataset.required === 'true');
		}

		this.findInputByName();
		this.initIntlTelInput();
		this.bootstrapIntlTelInput().then(() => {
			super.init();
			this.refreshInputValue();
		}).catch((err) => {
			console.error('Intl Tel Input: ', err);
		});
	}

	/* Initialize Intl-Tel-Input lib */
	initIntlTelInput() {
		this.iti = intlTelInput(this.$input, {
			utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@23.6.1/build/js/utils.js',
			initialCountry: 'ua',
			nationalMode: false,
			separateDialCode: true,
			countryOrder: ['ua', 'us'],
			excludeCountries: ['ru', 'by', 'kz', 'am', 'kg', 'tj']
		});
	}

	bootstrapIntlTelInput() {
		return this.iti.promise.then(() => {
			this.$root.querySelectorAll('.iti__flag').forEach(item => {
				item.dataset.backgroundImage = (`${craft.env.assetsSiteUrl + '/assets/images/Extensions/flags.png'}`);
				item.classList.add('lozad');
			});
			lozadObserver.observe();
			this.getMaskPattern();
			this.initInputMask();
		});
	}

	/* Initialize IMask lib */
	initInputMask() {
		VMasker(this.$input).maskPattern(this.maskPattern);
	}

	refreshInputValue(shouldDispatchEvent = true) {
		super.refreshInputValue();

		if (!this.maskPattern) {
			return;
		}

		this.$input.value = VMasker.toPattern(this.$input.value, this.maskPattern);

		if (shouldDispatchEvent) {
			this.$input.dispatchEvent(new Event('input'));
			this.$input.blur();
		}
	}

	getMaskPattern() {
		this.selectedCountry = this.iti.getSelectedCountryData().iso2;

		const numberExample = intlTelInput.utils.getExampleNumber(this.selectedCountry, false, 1);
		let pattern = numberExample.split(' ');
		pattern.shift();
		this.maskPattern = pattern.join(' ').replace(/\d/g, '9');

		// Allow numbers with several digit number for these countries
		if (this.selectedCountry === 'bg') {
			this.maskPattern += '9';
		} else if (this.selectedCountry === 'at') {
			this.maskPattern += '99';
		}
	}

	addEventListeners() {
		this.$input.addEventListener('input', this.handleInput.bind(this));
		this.$input.addEventListener('blur', this.handleBlur.bind(this));
		this.$input.addEventListener('countrychange', this.handleCountryChange.bind(this));
		this.$input.addEventListener('open:countrydropdown', this.handleCoutryDropdownOpen.bind(this));
		this.$input.addEventListener('close:countrydropdown', this.handleCoutryDropdownClose.bind(this));
	}

	handleInput(e) {
		let value = e.target.value;

		if (value.length > 9) {
			value = value.replace(/^\+?380/, '');
		}

		this.$input.value = VMasker.toPattern(value, this.maskPattern);
		this.setValue(this.$input.value);

		if (this.required) {
			this.validateSoft();
		}
	}

	handleBlur() {
		if (this.required) {
			this.validateStrict();
		}
	}

	handleCountryChange() {
		this.getMaskPattern();
		this.initInputMask();
		this.setValue('');
		this.$input.value = '';
		this.validateSoft();
	}

	handleCoutryDropdownOpen() {
		const countryListbox = document.querySelector('.iti__country-list[role="listbox"]');

		if (this.modalService.isOpened) {
			scrollLock.disablePageScroll(countryListbox);
		}

		countryListbox.querySelectorAll('.iti__flag').forEach(item => {
			item.dataset.backgroundImage = (`${craft.env.assetsSiteUrl + '/assets/images/Extensions/flags.png'}`);
			item.classList.add('lozad');
		});
		lozadObserver.observe();
	}

	handleCoutryDropdownClose() {
		if (this.modalService.isOpened) {
			const countryListbox = document.getElementById('country-listbox');
			scrollLock.enablePageScroll(countryListbox);
		}
	}

	validate() {
		this.isValid = intlTelInput.utils.isValidNumber(this.value, this.iti.getSelectedCountryData().iso2);
		const exampleNumberLength = this.maskPattern.split(' ').join('').length;

		if (!this.isValid &&
			this.value &&
			this.value.length === exampleNumberLength &&
			(this.selectedCountry === 'bg' ||
				// Bug fix when a valid israel phone number does not pass validation
				this.selectedCountry === 'il' && this.value.slice(0, 2) === '55')) {
			this.isValid = true;
		}
	}

	getValue() {
		return this.iti.getNumber();
	}

	setValue(value) {
		value = value.replace(/[\s-]/g, '');
		super.setValue(value);
	}

	getData() {
		return { [this.name]: this.iti.getNumber() };
	}

	setInitialValue(value) {
		if (value.length > 9) {
			value = value.replace(/^\+?380/, '');
		}

		super.setInitialValue(value);
	}

	setInitialState() {
		this.setValue('');
		this.refreshInputValue();
	}
}